import { Component, Input, OnInit } from '@angular/core';
import { AggregationService } from '../_services/aggregation.service';
import { PersonSearchService } from '../_services/person-search.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as _ from 'underscore';


@Component({
    selector: 'app-similarity-insights-modal',
    templateUrl: './similarity-insights-modal.component.html',
    styleUrls: ['./similarity-insights-modal.component.scss'],
    standalone: false
})
export class SimilarityInsightsModalComponent implements OnInit {

  @Input() similarElasticId;
  @Input() candidateElasticId;
  @Input() similarCandidateFullName;
  @Input() candidateName;
  request: any;
  candidateCompareData: any;
  overallExplanationCommon: string;
  overallExplanationDiverge: string;
  commonArray: any[] = [];
  gapArray: any[] = [];
  comparisonKeys: any[] = [];
  showLoaderbeforeDataLoad: Boolean = false;
   rowLimit = 3;      // show 3 rows initially
  showAll = false;
  @Input() referenceCandidateData;
  maxScoreArray: any[] = [];
  minScoreArray: any[] = [];
  showEmptyImage: Boolean = false;

  constructor(private aggregationService: AggregationService, private personSearchService: PersonSearchService, private modalService: NgbModal) { }

  ngOnInit() {
    this.request = this.aggregationService.getRequestWithFilters();
    this.getCandidateInsights();
  }

  getCandidateInsights() {
    this.showEmptyImage = false;
    this.showLoaderbeforeDataLoad = true;
    let payload = {
      referenceelasticid: this.similarElasticId,
      tocompareelasticid: this.candidateElasticId,
    }
    if(!this.similarElasticId) {
      delete payload['referenceelasticid'];
      delete this.referenceCandidateData.isUploadedFromResume;
      delete this.referenceCandidateData.toYrsOfExperinece;
      delete this.referenceCandidateData.fromYrsOfExperience;

      payload['refrencecandidatedata'] = this.removeIsMandatory(this.referenceCandidateData);
    }
    this.personSearchService.candidateCompare(payload).subscribe((res:any)=>{
      this.showLoaderbeforeDataLoad = false;
      if(res.status == 'success') {
        this.candidateCompareData = res.data;
        this.overallExplanationCommon = this.candidateCompareData?.overall_explanation?.what_they_have_in_common;
        this.overallExplanationDiverge = this.candidateCompareData?.overall_explanation?.where_they_diverge;
        this.commonArray = Object.keys(this.candidateCompareData).filter(key => this.candidateCompareData[key]?.score >= 4).map(key => ({ key, ...this.candidateCompareData[key] }));
        this.gapArray = Object.keys(this.candidateCompareData).filter(key => this.candidateCompareData[key]?.score == 0 || this.candidateCompareData[key]?.score < 4).map(key => ({ key, ...this.candidateCompareData[key] }));
        this.comparisonKeys = Object.keys(this.candidateCompareData).filter(key => typeof this.candidateCompareData[key] === 'object' && key !== 'overall_explanation');
        this.maxScoreArray = this.commonArray.filter(x=>x.score >= 7);
        this.minScoreArray = this.commonArray.filter(x=>(x.score >= 4 && x.score < 7));
        this.commonArray = _.sortBy(this.commonArray, "score").reverse();

      }

    }, (error)=>{
      this.showEmptyImage = true;
    })

  }

  closeModal() {
    this.modalService.dismissAll();
  }

    showMore() {
    this.showAll = true;
  }

  showLess() {
    this.showAll = false;
  }

  removeIsMandatory(obj: any): any {
  if (Array.isArray(obj)) {
    return obj.map(item => this.removeIsMandatory(item));
  } else if (typeof obj === 'object' && obj !== null) {
    const newObj: any = {};
    for (const key in obj) {
      if (key !== 'isMandatory') {
        newObj[key] = this.removeIsMandatory(obj[key]);
      }
    }
    return newObj;
  }
  return obj;
}

 formattedText(text) {
  return text.replace(/\*\*(.*?)\*\*/g, '<b>$1</b>');
}

}
